import classNames from "classnames";
import styles from "./Truncate.module.css";
import { useLayoutEffect, useState } from "react";
import Tooltip from "../Tooltip/Tooltip";

function Truncate({
  children,
  className,
  hideTooltip,
}: {
  children: React.ReactNode;
  className?: string;
  hideTooltip?: boolean;
}) {
  const [outerRef, setOuterRef] = useState<HTMLParagraphElement | null>(null);
  const [innerRef, setInnerRef] = useState<HTMLSpanElement | null>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useLayoutEffect(() => {
    if (hideTooltip) {
      return;
    }

    const onResize = () => {
      setShowTooltip(
        !!outerRef &&
          !!innerRef &&
          Math.floor(innerRef.getBoundingClientRect().width) >
            outerRef.clientWidth,
      );
    };

    const resizeObserver = new ResizeObserver(onResize);

    if (outerRef) {
      resizeObserver.observe(outerRef);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [hideTooltip, innerRef, outerRef]);

  if (showTooltip) {
    return (
      <Tooltip content={children}>
        <p ref={setOuterRef} className={classNames(styles.truncate, className)}>
          <span ref={setInnerRef}>{children}</span>
        </p>
      </Tooltip>
    );
  }

  return (
    <p ref={setOuterRef} className={classNames(styles.truncate, className)}>
      <span ref={setInnerRef}>{children}</span>
    </p>
  );
}

export default Truncate;
